export function Paywall({ onClose, onSubscribe }: { onClose: () => void; onSubscribe: () => void }) {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-2xl p-8 w-full max-w-md shadow-2xl text-center" onClick={e => e.stopPropagation()}>
        <div className="text-5xl mb-4">🔒</div>
        <h2 className="text-2xl font-bold mb-2">继续阅读需要订阅</h2>
        <p className="text-gray-600 mb-6">免费试读已结束，订阅后可解锁完整绘本和全部功能</p>
        <div className="space-y-3 mb-6">
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-4 rounded-xl">
            <div className="font-bold text-lg">年付会员</div>
            <div className="text-2xl font-bold text-blue-600">¥39<span className="text-sm text-gray-500 font-normal">/年</span></div>
          </div>
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-xl">
            <div className="font-bold text-lg">终身会员</div>
            <div className="text-2xl font-bold text-purple-600">¥79<span className="text-sm text-gray-500 font-normal">/一次性</span></div>
          </div>
        </div>
        <button onClick={onSubscribe}
          className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 rounded-xl font-bold hover:opacity-90 transition">
          立即订阅
        </button>
        <button onClick={onClose} className="mt-3 text-sm text-gray-500 hover:text-gray-700">
          稍后再说
        </button>
      </div>
    </div>
  );
}
